import { Translate } from 'react-localize-redux';
import { useSelector } from 'react-redux';
import { useI18n } from 'services/i18n/i18n.hooks';
import { selectPendingSessions } from 'services/pendingSessions/pendingSessions.selectors';
import { AppState } from 'store/types';
import {
  LastAccessText,
  StatsItem,
  StatsLabel,
  StatsSummaryContainer,
  StatsValue,
} from './style/StatsSummary.style';

export default function StatsSummary() {
  const pendingSessions = useSelector(selectPendingSessions);
  const { totalSessionBalance, updatedAt } = pendingSessions;

  const userBalance = useSelector(
    (state: AppState) => state.user.balance.realCashBalance,
  );

  const {
    formatters: { formatCurrency, formatDate, formatTimeShort },
  } = useI18n();

  return (
    <StatsSummaryContainer>
      <StatsItem>
        <StatsLabel>
          <Translate id="lbl.pendingSessionModal.balance" />
        </StatsLabel>
        <StatsValue>{formatCurrency(userBalance)}</StatsValue>
      </StatsItem>
      <StatsItem>
        <StatsLabel>
          <Translate id="lbl.pendingSessionModal.funds" />
        </StatsLabel>
        <StatsValue>{formatCurrency(totalSessionBalance)}</StatsValue>
      </StatsItem>
      <LastAccessText>
        <Translate id="lbl.pendingSessionTimeUpdatedAt.date" />
        {formatDate(updatedAt)}
        <Translate id="lbl.pendingSessionTimeUpdatedAt.time" />
        {formatTimeShort(updatedAt)}
      </LastAccessText>
    </StatsSummaryContainer>
  );
}
